import { render } from "./LayoutsRow.vue?vue&type=template&id=bd9affc4"
import script from "./LayoutsRow.vue?vue&type=script&lang=js"
export * from "./LayoutsRow.vue?vue&type=script&lang=js"

import "./LayoutsRow.vue?vue&type=style&index=0&id=bd9affc4&lang=scss"

import exportComponent from "C:\\agent\\_work\\39\\s\\Infosit.Cms.Web.v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__